export default __webpack_public_path__ + "static/media/coming-soon.6ea773fd.png";